import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=0d8be594&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"
import style0 from "./promotion.vue?vue&type=style&index=0&id=0d8be594&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8be594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8be594')) {
      api.createRecord('0d8be594', component.options)
    } else {
      api.reload('0d8be594', component.options)
    }
    module.hot.accept("./promotion.vue?vue&type=template&id=0d8be594&scoped=true", function () {
      api.rerender('0d8be594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/promotion.vue"
export default component.exports